/**
 * In this file use to contains the physician Module Measurement screen UI and Logic
 **/
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { goBack } from "./../../../services/UtilsService";
import ApiService from "./../../../services/ApiService";
import {
  convertDOBtoAge,
  convertDOBtoMonth,
  formatMeasurement,
  convertS3privateToPublic,
} from "./../../../services/UtilsService";
import Pagination from "./../../../shared/components/Pagination";
import Filter from "./../../../shared/components/Filter";
import ChartModal from "./../../../shared/modals/ChartModal";
import MeasurementChart from "./../../../shared/modals/MeasurementChartModal";
import MessageModal from "./../../../shared/modals/MessageModal";
import DevelopmentModal from "./../../../shared/modals/DevelopmentModal";
import VaccinationModal from "./../../../shared/modals/VaccinationModal";
import MedicalIssueModal from "./../../../shared/modals/MedicalIssueModal";
import AppointmentsModal from "./../../../shared/modals/AppointmentsModal";
import { useTranslation } from 'react-i18next';

function Measurement() {
  const [modal, setModal] = useState({});
  const [request, setRequest] = useState({
    page: 0,
    limit: 10,
    clinics: [],
    age_range: [],
    sort: "updated",
  });
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [clinicList, setClinicList] = useState({});
  const [isFilterOpen, setFilterOpen] = useState(false);
  const [message, setMessage] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();
	
  //Component Initialize function when the request value change
  useEffect(() => {
	const fetchData = async () => {
		setIsLoading(true); 
		try {
			var response = await ApiService.listFamilyMember(request);
		    if (response.status === 200) {
				setData(response.data.data);
				setCount(response.data.count);
			}
		} catch (error) {
        console.error('Error fetching member measurement data:', error);
		} finally {
        setIsLoading(false); 
		}
	  };
	fetchData();
  }, [request]);

  //Component Initialize function
  useEffect(() => {
    (async () => {
      var clinicResponse = await ApiService.getPhysicainClinics();
      if (clinicResponse.status === 200) {
        setClinicList(clinicResponse?.data);
      }
    })();
  }, []);

  //To close message modal
  const closeMessage = () => {
    setMessage({});
  };

  /**
   * To handle pagination event
   * @data we pass the page number count
   **/
  const handlePaginate = (data) => {
    setRequest((req) => ({ ...req, page: data }));
  };

  //callback function
  const handleClose = () => setModal({});

  /**
   * To Fliter the Member list based on the Select clinics details
   * callback function for handleClinicChange
   * @e we get the event Details from the change function
   **/
  const handleClinicChange = (e) => {
    const { value, checked } = e.target;
    setRequest((request) => {
      if (checked) {
        return { ...request, clinics: [...request.clinics, value] };
      } else {
        return {
          ...request,
          clinics: request.clinics.filter((option) => option !== value),
        };
      }
    });
  };

  /**
   * To Fliter the Member list based on the Select Age Range details
   * callback function for handleAgeChange
   * @e we get the event Details from the change function
   **/
  const handleAgeChange = (e, item) => {
    const { value, checked } = e.target;
    setRequest((request) => {
      if (checked) {
        return { ...request, age_range: [...request.age_range, value] };
      } else {
        return {
          ...request,
          age_range: request.age_range.filter((option) => option !== value),
        };
      }
    });
  };

  /**
   * To close the Dashboard Fliter Opction with the cross mark button
   **/
  const handleDismiss = () => {
    setFilterOpen(false);
  };

  return (
    <main id="main" className="main">
      {/*import DevelopmentModal*/}
      {Object.keys(modal).length !== 0 && modal.development && (
        <DevelopmentModal data={modal} handleClose={handleClose} />
      )}

      {/*import VaccinationModal*/}
      {Object.keys(modal).length !== 0 && modal.vaccination && (
        <VaccinationModal data={modal} handleClose={handleClose} />
      )}

      {/*import MedicalIssueModal*/}
      {Object.keys(modal).length !== 0 && modal.medication && (
        <MedicalIssueModal data={modal} handleClose={handleClose} />
      )}

      {/*import AppointmentsModal*/}
      {Object.keys(modal).length !== 0 && modal.appointment && (
        <AppointmentsModal data={modal} handleClose={handleClose} />
      )}

      {/*import ChartModal*/}
      {Object.keys(modal).length !== 0 && modal.chart && (
        <ChartModal data={modal} handleClose={handleClose} />
      )}

      {/*import MeasurementChart*/}
      {Object.keys(modal).length !== 0 && modal.measurement && (
        <MeasurementChart data={modal} handleClose={handleClose} />
      )}

      {/*MessageModal*/}
      {Object.keys(message).length !== 0 && (
        <MessageModal data={message} handleClose={closeMessage} />
      )}

      {/*import Filter*/}
      {
        <Filter
          handleClinicChange={handleClinicChange}
          handleAgeChange={handleAgeChange}
          clinicList={clinicList}
          handleSidebarToggle={isFilterOpen}
          handleDismiss={handleDismiss}
        />
      }
      {/* Page Title Section */}
      <div className="pagetitle clearfix">
        <div className="float-start">
          <h1>{t('sidebar.measurement')}</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/physician/dashboard">
                  {t('sidebar.home')}
                </Link>
              </li>
              <li className="breadcrumb-item active">{t('sidebar.measurement')} </li>
            </ol>
          </nav>
        </div>
        <div className="float-end mt-2 me-1">
          <span onClick={goBack} className="backIcon">
            <i className="iconly-Bold-ArrowLeftSquare"></i>
          </span>
        </div>
        {/* End Buttons */}
      </div>
      {/*End Page Title Section */}
      {/* Page Content Section */}
      <section className="pagesection">
        {/* Search */}
        <div className="row my-3">
          <div className="col-xxl-8 col-lg-8 d-flex">
            <div className="input-group input-group-sm me-2 w-50">
              <input
                type="text"
                onChange={(e) =>
                  setRequest((req) => ({
                    ...req,
                    search: e.target.value,
                    page: 0,
                  }))
                }
                className="form-control"
                placeholder={t('common.search')}
              />
              <button className="btn btn-tmBlue" type="button">
                <i className="ri-search-line align-middle"></i>
              </button>
            </div>
          </div>
          <div className="col-xxl-4 col-lg-4">
            <div className="dropdown float-end me-3">
              <a
                href="javascript;"
                className="btn btn-sm btn-outline-tmBlue dropdown-toggle"
                role="button"
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {" "}
                {t('common.sort')}{" "}
              </a>

              <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <li
                  onClick={() =>
                    setRequest((req) => ({ ...req, sort: "created" }))
                  }
                >
                  <span
                    className={
                      request.sort === "created"
                        ? "dropdown-item active"
                        : "dropdown-item"
                    }
                  >
                    {" "}
                    {t('common.recentAdded')}
                  </span>
                </li>
                <li
                  onClick={() =>
                    setRequest((req) => ({ ...req, sort: "updated" }))
                  }
                >
                  <span
                    className={
                      request.sort === "updated"
                        ? "dropdown-item active"
                        : "dropdown-item"
                    }
                  >
                    {" "}
                    {t('common.recentUpdated')}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* End Search */}
        {/* Table */}
        <div className="row my-3">
          <div className="col-xxl-12">
            <div className="table-responsive">
              <table className="table table-borderless theme-table">
                <thead>
                  <tr>
                    <th scope="col">{t('table.memberDetails')}</th>
                   {/*  <th scope="col" className="text-center">
                      {t('table.analytics')}
                    </th> */}
                    <th scope="col" className="text-center">
                      {t('table.weight')}
                    </th>
                    <th scope="col" className="text-center">
                      {t('common.deviceName')}
                    </th>
                    <th scope="col" className="text-center">
                      {t('table.height')}
                    </th>
                    <th scope="col" className="text-center">
                      {t('table.head')}
                    </th>
                    <th scope="col" className="text-center">
                      {t('table.bloodGroup')}
                    </th>
                    <th scope="col" className="text-center">
                      {t('table.add')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data &&
                    data.length !== 0 &&
                    data.map((item, i) => (
                      <tr
                        key={i}
                        className={item.gender === 0 ? "male" : "female"}
                      >
                        <td>
                          <div className="d-flex align-items-center ps-1z text-capitalize">
                            <div className="avtar-img">
                              <span className="rounded-circle">
                                {item?.photo === "default.png" ? (
                                  <img
                                    src="/assets/img/user-avatar.png"
                                    alt="UN"
                                  />
                                ) : (
                                  <img
                                    src={convertS3privateToPublic(item?.photo)}
                                    alt="UN"
                                  />
                                )}
                              </span>
                            </div>
                            <div className="ms-3">
                              <Link
                                to={"/physician/member-profile/" + item?.id}
                              >
                                <h5 className="table-title fw-bold">
                                  {item.name}
                                </h5>
                              </Link>
                              <p className="table-subtitle">
                                <span>
                                  {item.gender === 0 ? t('common.boy') :  t('common.girl')}
                                </span>{" "}
                                - {convertDOBtoAge(item.dob, t)}
                              </p>
                              <div className="icon-link">
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    setModal({
                                      development: true,
                                      id: item.id,
                                      parent: item.parent,
                                      name: item.name,
                                    })
                                  }
                                  className="me-1 text-tmGreen"
                                >
                                  <i
                                    className="fa-solid fa-chart-column"
                                    title= {t('sidebar.development')}
                                  ></i>
                                </span>
                                <span
                                  style={{ cursor: "pointer" }}
                                  className="me-1 text-tmBlue"
                                  onClick={() =>
                                    setModal({
                                      vaccination: true,
                                      member: item.id,
                                      dob: convertDOBtoMonth(item.dob, t),
                                      name: item.name,
                                      parent: item.parent,
                                    })
                                  }
                                >
                                  <i
                                    className="fa-solid fa-syringe"
                                    title= {t('sidebar.vaccination')}
                                  ></i>
                                </span>
                                <span
                                  style={{ cursor: "pointer" }}
                                  className="me-1 text-tmPink"
                                  onClick={() =>
                                    setModal({
                                      medication: true,
                                      member: item.id,
                                      name: item.name,
                                      parent: item.parent,
                                    })
                                  }
                                >
                                  <i
                                    className="fa-solid fa-hospital-user"
                                    title= {t('sidebar.medicalIssues')}
                                  ></i>
                                </span>
                                <span
                                  style={{ cursor: "pointer" }}
                                  className="me-1 text-tmPurple"
                                >
                                  <i
                                    className="fa-regular fa-calendar-days"
                                    onClick={() =>
                                      setModal({
                                        appointment: true,
                                        member: item.id,
                                        name: item.name,
                                      })
                                    }
                                    title= {t('sidebar.appointments')}
                                  ></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </td>
                      {/*   <td className="text-center">
                          <span>
                            {item?.interactiontime
                              ? item.interactiontime
                              : "00:00:00"}
                          </span>
                        </td> */}
                        <td className="text-center">
                          <span
                            className="table-link"
                            onClick={() =>
                              setModal({
                                measurement: true,
                                member: item.id,
                                chartName: "Weight",
                                gender: item.gender,
                                parent: item.parent,
                                dob: item?.dob,
                                name: item.name,
                              })
                            }
                          >
                            {item?.latest_weight
                              ? formatMeasurement(item.latest_weight) + ` ${t('common.kg')}`
                              : "--"}
                          </span>
                        </td>
                        <td className="text-center"> {item.weight_device_name ? item.weight_device_name : '--'}</td>
                        <td className="text-center">
                          <span
                            className="table-link"
                            onClick={() =>
                              setModal({
                                measurement: true,
                                member: item.id,
                                chartName: "Height",
                                gender: item.gender,
                                parent: item.parent,
                                dob: item?.dob,
                                name: item.name,
                              })
                            }
                          >
                            {item?.latest_height
                              ? formatMeasurement(item.latest_height) + ` ${t('common.cm')}`
                              : "--"}
                          </span>
                        </td>
                        <td className="text-center">
                          <span>
                            {item?.latest_head_circumference
                              ? formatMeasurement(item.latest_head_circumference) + ` ${t('common.cm')}`
                              : "--"}
                          </span>
                        </td>
                        <td className="text-center">
                          <span>
                            {item?.blood_group ? item.blood_group : "--"}
                          </span>
                        </td>
                        <td className="text-center">
                          <Link
                            to={"/physician/add-measurement/" + item?.id}
                            className="table-link text-tmBlue"
                          >
                            <i className="ri-add-box-fill align-middle fw-normal"></i>{" "}
                          </Link>
                        </td>
                      </tr>
                    ))}
                  {data.length === 0 && !isLoading && (
                    <tr>
                      <td colSpan="11" className="text-center">
                        {t('common.noRecord')}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* End Table */}
        {/* Pagination */}
        <div className="row my-3">
          <div className="col-xxl-12 d-flex justify-content-center">
            {data.length !== 0 && (
              <Pagination
                page={request.page}
                handlePaginate={handlePaginate}
                total={count}
              />
            )}
          </div>
        </div>
        {/* End Pagination */}
      </section>
      {/* End Page Content Section */}
    </main>
  );
}

export default Measurement;
